function PetitionResults(el) {
    this.el = el;
    this.postId = el.dataset.postId;
    this.searchInput = el.querySelector('.jsPetitionResultsSearch');
    this.resultsList = el.querySelector('.jsPetitionResultsList');
    this.paginationContainers = el.querySelectorAll('.jsPetitionResultsPagination');
    this.currentPage = 1;
    this.searchQuery = '';
    this.searchTimeout = null;
    this.maxPages = parseInt(el.dataset.maxPages) || 1;

    this.init();
}

PetitionResults.prototype.init = function() {
    if (this.searchInput) {
        this.searchInput.addEventListener('keyup', (e) => {
            this.handleSearch(e.target.value);
        });
    }

    this.setupPagination();
    this.updatePaginationVisibility();

    // Get current page from existing pagination if available
    const currentPageEl = this.el.querySelector('.page-numbers.current');
    if (currentPageEl) {
        const page = parseInt(currentPageEl.textContent);
        if (page && !isNaN(page)) {
            this.currentPage = page;
        }
    }

    // Load initial results via AJAX to ensure correct data
    this.loadResults();
};

PetitionResults.prototype.handleSearch = function(query) {
    this.searchQuery = query.trim();

    if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
    }

    this.searchTimeout = setTimeout(() => {
        this.currentPage = 1;
        this.loadResults();
    }, 200);
};

PetitionResults.prototype.setupPagination = function() {
    this.paginationContainers.forEach(container => {
        container.addEventListener('click', (e) => {
            const target = e.target;
            if (!target.classList.contains('page-numbers') || target.classList.contains('current')) {
                return;
            }

            if (target.classList.contains('next')) {
                if (this.currentPage < this.maxPages) {
                    this.currentPage++;
                    this.loadResults(true);
                }
            }
            else {
                const pageNumber = parseInt(target.textContent);
                if (pageNumber && pageNumber !== this.currentPage) {
                    this.currentPage = pageNumber;
                    this.loadResults(true);
                }
            }
        });
    });
};

PetitionResults.prototype.loadResults = function(isPagination) {
    const params = {
        action: 'se_get_petition_results',
        postId: this.postId,
        pageNumber: this.currentPage,
        searchQuery: this.searchQuery
    };

    se_postRequest(se_ajax.ajaxurl, params, (response) => {
        try {
            const data = JSON.parse(response);

            if (data.err) {
                console.error('Error loading petition results:', data.err);
                return;
            }

            this.maxPages = data.max_num_pages || 1;
            this.currentPage = data.current_page || 1;

            if (this.resultsList) {
                const header = this.resultsList.querySelector('.result-header');
                this.resultsList.innerHTML = '';
                if (header) {
                    this.resultsList.appendChild(header);
                }
                this.resultsList.insertAdjacentHTML('beforeend', data.html);
            }

            this.paginationContainers.forEach(container => {
                container.innerHTML = data.pagination || '';
            });

            this.updatePaginationVisibility();

            if (isPagination) {
                this.scrollToElementIfOutOfView();
            }
        }
        catch (error) {
            console.error('Error parsing response:', error);
        }
    }, () => {
        console.error('Error loading petition results');
    });
};

PetitionResults.prototype.updatePaginationVisibility = function() {
    this.paginationContainers.forEach(container => {
        if (this.maxPages < 2) {
            container.style.display = 'none';
        }
        else {
            container.style.display = '';
        }
    });
};

PetitionResults.prototype.isElementOutOfView = function() {
    const rect = this.el.getBoundingClientRect();
    return rect.top < 0;
};

PetitionResults.prototype.scrollToElementIfOutOfView = function() {
    if (this.isElementOutOfView()) {
        const elementTop = this.el.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
            top: elementTop,
            behavior: 'smooth'
        });
    }
};

(function() {
    const petitionResultsEls = document.querySelectorAll('.jsPetitionResults') || [];
    for (let i = 0; i < petitionResultsEls.length; i++) new PetitionResults(petitionResultsEls[i]);
})();